// Add your custom JS here.

jQuery(document).ready(function ($) {
	var swiper = new Swiper(".mySwiper", {
		slidesPerView: 3,
		spaceBetween: 37,
		slidesPerGroup: 3,
		loop: true,
		infinite: true,
		mousewheel: false,
		autoplay: false,


				
		preventClicks: false,
		preventClicksPropagation: false,
		slideToClickedSlide: false,


		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 1,
				touchRatio: 0,
				mousewheel: false,
				slidesPerGroup: 1,
				grid: {
					rows: 6,
				},
			},
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				mousewheel: false,
			},
			// when window width is >= 640px
			992: {
				slidesPerView: 3,
				mousewheel: false,
				slidesPerGroup: 3,
			},
		},
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		mousewheel: true,
		keyboard: true,
	});

	$("#service").click(function () {
		$(".service-box").toggleClass("show-box");
	});
	$("#service2").click(function () {
		$(".service-box").toggleClass("show-box");
	});

	$(".form-select-categories").select2({
		placeholder: "All Categories",
	});

	$(".form-select-tags").select2({
		placeholder: "All Tags",
	});

	$(".form-select-resource-type").select2({
		placeholder: "All Resources",
	});

	$(".form-select-sector").select2({
		placeholder: "All Sectors",
	});

	// Trigger form submission on search input Enter key press
	$("#resource-hub-search").on("submit", function (e) {
		e.preventDefault();
		submitForm();
	});

	// Trigger form submission when a select option is changed
	$(".form-select").on("change", function () {
		submitForm();
	});

	function submitForm() {
		console.log("Form submission triggered");

		var searchData = {
			action: "filter_posts", // The function name to handle this request on the server-side
			query_vars: $("#resource-hub-search").serialize(), // Serialize the form data
		};

		$.ajax({
			url: ajax_params.ajax_url, // Make sure ajax_params.ajax_url is correctly defined
			data: searchData,
			type: "POST",
			beforeSend: function () {
				// Show the loading indicator
				$("#loading-indicator").show();
			},
			success: function (response) {
				$("#ajax-posts").html(response); // Replace the content with the response data
			},
			complete: function () {
				// Hide the loading indicator
				$("#loading-indicator").hide();
			},
			error: function () {
				// Optional: Handle errors
				console.error("An error occurred");
				// Hide the loading indicator in case of error as well
				$("#loading-indicator").hide();
			},
		});
	}
});

jQuery(document).ready(function ($) {
	$(".logo-list.slid").slick({
		// Your slick options here
		dots: false,
		arrows: false,
		infinite: true,
		speed: 300,
		slidesToShow: 6,
		adaptiveHeight: true,
		autoplay: true,
		autoplaySpeed: 2000,
		centerMode: true,
		variableWidth: true,
		responsive: [
			// {
			// 	breakpoint: 768,
			// 	settings: {
			// 		arrows: false,
			// 		centerMode: true,
			// 		centerPadding: "40px",
			// 		slidesToShow: 3,
			// 	},
			// },
			{
				breakpoint: 575,
				settings: {
					centerMode: true,
					adaptiveHeight: false,
					slidesToShow: 1,
				},
			},
		],
	});

	if ($(window).width() < 640) {
		$(".logo-list.noslid").slick({
			// Your slick options here
			dots: false,
			arrows: false,
			infinite: true,
			speed: 300,
			adaptiveHeight: false,
			autoplay: true,
			autoplaySpeed: 2000,
			centerMode: true,
			variableWidth: true,
			centerMode: true,
			slidesToShow: 1,
		});
	}
});

jQuery(document).ready(function ($) {
	// get data-autoplay and data-autoplay-speed attributes
	var autoplay = $(".sliding-hero-banner-block").data("autoplay");
	// convert autoplay to boolean
	autoplay = !!autoplay;
	var autoplaySpeed = $(".sliding-hero-banner-block").data("autoplay-speed");
	$(".sliding-hero-banner-block").slick({
		autoplay: autoplay,
		autoplaySpeed: autoplaySpeed,
		dots: true,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: "linear",
		// additional options here
	});
});

jQuery(document).ready(function ($) {
	$(".video-trigger").magnificPopup({
		type: "iframe", // This assumes your video URL is suitable for iframing
		// Other options here
	});
});

jQuery(document).ready(function ($) {
	// Prevent clicks within the dropdown from closing the mega menu
	$(".dropdown-menu").on("click", function (e) {
		e.stopPropagation();
	});
	// Close the mega menu when clicking outside
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".navbar-nav .dropdown").length) {
			$(".navbar-nav .dropdown .dropdown-menu").removeClass("show");
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	// Use event delegation to handle clicks on dropdown items
	document
		.querySelector("#navbar_top")
		.addEventListener("click", function (event) {
			if (window.innerWidth < 992) {
				// Only for mobile view
				var clickedElement = event.target;
				if (clickedElement.matches(".dropdown-toggle")) {
					// Prevent default link behavior
					event.preventDefault();
					// Toggle the display of the nested dropdown menu
					var submenu = clickedElement.nextElementSibling;
					// if (submenu.style.display === "block") {
					// 	submenu.style.display = "none";
					// } else {
					// 	submenu.style.display = "block";
					// }
				}
			}
		});
});

// document.addEventListener("DOMContentLoaded", function () {
// 	function centerMegaMenu() {
// 		// Only run this logic on screens wider than 991px
// 		if (window.innerWidth <= 991) {
// 			return;
// 		}

// 		const megaMenus = document.querySelectorAll(".mega-menu");

// 		megaMenus.forEach((menu) => {
// 			// Reset styles to get the actual size and position
// 			menu.style.left = "-50%";
// 			menu.style.right = "auto";
// 			menu.style.transform = "translateX(-55%)";

// 			const rect = menu.getBoundingClientRect();

// 			// Check if the menu is still protruding out of the viewport after centering
// 			const protrudesLeft = rect.left < 0;
// 			const protrudesRight = rect.right > window.innerWidth;

// 			// If the menu is protruding on either side, adjust
// 			if (protrudesLeft || protrudesRight) {
// 				if (protrudesLeft) {
// 					// If it's protruding to the left, align it to the left edge
// 					menu.style.left = "0";
// 					menu.style.transform = "translateX(-24%)";
// 				}
// 				if (protrudesRight) {
// 					// If it's protruding to the right, align it to the right edge
// 					menu.style.left = "auto";
// 					menu.style.right = "0";
// 					menu.style.transform = "translateX(0%)";
// 				}
// 			}

// 			// Make the menu visible again after adjustments
// 			menu.style.visibility = "visible";
// 		});
// 	}

// 	// Add event listener for window resize
// 	window.addEventListener("resize", centerMegaMenu);

// 	// Center the mega menu when its dropdown is shown
// 	const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
// 	dropdownToggles.forEach((toggle) => {
// 		toggle.addEventListener("click", () => {
// 			// Introduce a slight delay to allow for dropdown to show
// 			setTimeout(centerMegaMenu, 10);
// 		});
// 	});

// 	// Initial centering on page load
// 	centerMegaMenu();
// });

jQuery(document).ready(function ($) {
	$(document).scroll(function () {
		if ($(this).scrollTop() > 300) {
			$("#scrollTopBtn").fadeIn();
		} else {
			$("#scrollTopBtn").fadeOut();
		}
	});
});



jQuery('[data-moburl]').on('click', function (e) {
	if(jQuery(window).width() < 992) {
		e.preventDefault();
		window.location = jQuery(this).data('moburl');
	}
});



jQuery('.studie-box.text-box').on('click', function() {
    if(jQuery(this).find('a').length) {
        window.location.href = jQuery(this).find('a').attr('href');
    }
});

jQuery(window).on('load', function() {
	if(jQuery('.autochangeme').length) {    
		jQuery('#resource-hub-search').submit();
	}
});







function toggleClearFilter() {
	var hasValues = false;
	jQuery('#resource-hub-search').find('input, select').each(function () {
	  if (jQuery(this).is('select')) {
		if (jQuery(this).val().length) hasValues = true;
	  } else {
		if (jQuery(this).val().length) hasValues = true;
	  }
	});
	if (jQuery('.clearall').length) {
	  // Check if .clearall exists
	  if (hasValues) {
		jQuery('.clearall').show();
	  } else {
		jQuery('.clearall').hide();
	  }
	}
	if (jQuery('.clearsome').length) {
	  // Check if .clearsome exists
	  if (hasValues) {
		jQuery('.clearsome').show();
	  } else {
		jQuery('.clearsome').hide();
	  }
	}
  }

toggleClearFilter();

jQuery(document).on('change', '#resource-hub-search :input', function() {
	toggleClearFilter();
});

jQuery('.clearall').on('click', function () {
	jQuery('#resource-hub-search').find('input, select').each(function () {
	  if (jQuery(this).is('select')) {
		jQuery(this).val('').trigger('change');
	  } else {
		jQuery(this).val('');
	  }
	});
	jQuery('#resource-hub-search').submit();
  });
jQuery('.clearsome').on('click', function () {
	jQuery('#resource-hub-search').find('input, select').each(function () {
		// Skip the category field by checking its name
		if (jQuery(this).is('select') && jQuery(this).attr('name') !== 'categories[]') {
		jQuery(this).val('').trigger('change');
		} else if (jQuery(this).is('input')) {
		jQuery(this).val('');
		}
	});
	jQuery('#resource-hub-search').submit();
});

  /* Help Widget */

  jQuery('.helpwidgettooltip, .helpwidgetbubble').on('click', function(e) {
      jQuery('.helpwidget').toggleClass('activehelp');
});



jQuery('a[href="#livechat"]').on('click', function(e) {
      e.preventDefault();
      window.HubSpotConversations.widget.load(); window.HubSpotConversations.widget.open();
      jQuery('.helpwidget').removeClass('activehelp');
      jQuery('.helpwidget').addClass('chatopen');

      //    Set session cookie called "livechatisopen" to true across the whole site
      document.cookie = "livechatisopen=true; path=/;";

      //    Unset the cookie
      
            
      window.HubSpotConversations.on('widgetClosed', (event) => {
            // console.log(event);
            jQuery('.helpwidget').removeClass('chatopen');
            document.cookie = "livechatisopen=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            window.HubSpotConversations.widget.remove();
      });
});